import React, { useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  Area,
  AreaChart
} from 'recharts';
import {TablePagination, Button, Box} from '@mui/material';
import * as XLSX from 'xlsx';
import { GetApp } from '@mui/icons-material';
import { useAccesos } from '../contexts/AccesosContext';


const normalize = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.$values)) return data.$values;
  return [];
};

const DashboardPausa= () => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  
  const [rangoFechas, setRangoFechas] = useState({
    inicio: new Date(),
    fin: new Date(),
  });
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);  

  const [resumen, setResumen] = useState({});
  const [motivos, setMotivos] = useState([]);
  const [porUsuario, setPorUsuario] = useState([]);
  const [pausasActivas, setPausasActivas] = useState([]);
  const [pausasPorHora, setPausasPorHora] = useState([]);
  const [pausasFinalizadas, setPausasFinalizadas] = useState([]);
  const [tipoFiltro, setTipoFiltro] = useState("activasTodas");
  const [pausasActivasTodas, setPausasActivasTodas] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const { tienePermiso } = useAccesos();
  

    const fetchSucursales = async () => {
      try {
        const response = await fetch(`${server}/tickets/tbl_motivo_pausa/dashboard/sucursales`, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          }
        });
        if (response.ok) {
          const data = await response.json();
          setSucursales(data.$values || data);
        }
      } catch (error) {
        console.error('Error al obtener sucursales:', error);
      }
    };

    // 🔥 Fetch principal
const fetchDatosDashboard = async () => {
  try {
    const inicio = rangoFechas.inicio.toISOString().split("T")[0];
    const fin = rangoFechas.fin.toISOString().split("T")[0];

    const sucursal = sucursalSeleccionada;

    let resumenUrl = `${server}/tickets/tbl_motivo_pausa/resumen?inicio=${inicio}&fin=${fin}`;
    let activasUrl = `${server}/tickets/tbl_motivo_pausa/activas?inicio=${inicio}&fin=${fin}&page=${page + 1}&limit=${rowsPerPage}`;
    let finalizadasUrl = `${server}/tickets/tbl_motivo_pausa/finalizadas?inicio=${inicio}&fin=${fin}&page=${page + 1}&limit=${rowsPerPage}`;
    let motivosUrl = `${server}/tickets/tbl_motivo_pausa/motivos?inicio=${inicio}&fin=${fin}`;
    let usuariosUrl = `${server}/tickets/tbl_motivo_pausa/por-usuario?inicio=${inicio}&fin=${fin}`;
    let activasTodasUrl = `${server}/tickets/tbl_motivo_pausa/activas-todas?page=${page + 1}&limit=${rowsPerPage}`;

    if (sucursal !== null) {
      resumenUrl += `&idSucursal=${sucursal}`;
      activasUrl += `&idSucursal=${sucursal}`;
      finalizadasUrl += `&idSucursal=${sucursal}`;
      motivosUrl += `&idSucursal=${sucursal}`;
    }

    const [
      resumenRes,
      motivosRes,
      usuariosRes,
      activasRes,
      finalizadasRes,
      activasTodasRes
    ] = await Promise.all([
      fetch(resumenUrl),
      fetch(motivosUrl),
      fetch(usuariosUrl),
      fetch(activasUrl),
      fetch(finalizadasUrl),
      fetch(activasTodasUrl)
    ]);

    const resumenData = await resumenRes.json();
    const motivosData = await motivosRes.json();
    const usuariosData = await usuariosRes.json();
    const activasData = await activasRes.json();
    const finalizadasData = await finalizadasRes.json();
    const activasTodasData = await activasTodasRes.json();

    const activasList = activasData.data || activasData;
    const finalizadasList = finalizadasData.data || finalizadasData;
    const activasTodasList = activasTodasData.data || activasTodasData;

    setResumen(resumenData);
    setMotivos(normalize(motivosData).map(m => ({
      name: m.motivoPausa,
      value: m.cantidad
    })));
    setPorUsuario(normalize(usuariosData));

    setPausasActivas(normalize(activasList));
    setPausasFinalizadas(normalize(finalizadasList));
    setPausasActivasTodas(normalize(activasTodasList));

    // 🔥 total dinámico según filtro
    if (tipoFiltro === "finalizadas") {
      setTotalRows(finalizadasData.total || finalizadasList.length);
    }
    else if(tipoFiltro === "activasTodas") {
      setTotalRows(activasTodasData.total || activasTodasList.length);
    } else {
      setTotalRows(activasData.total || activasList.length);
    }

  } catch (error) {
    console.error("Error cargando dashboard:", error);
  }
};
    useEffect(() => {
      fetchSucursales();
    }, []);

    useEffect(() => {
      fetchDatosDashboard();

      const interval = setInterval(() => {
        fetchDatosDashboard();
      }, 10000);

      return () => clearInterval(interval);

    }, [rangoFechas, sucursalSeleccionada, page, rowsPerPage, tipoFiltro]);

    const formatearTiempo = (minutos) => {
      if (minutos < 60) {
        return `${parseFloat(minutos.toFixed(2))}m`;
      }
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = parseFloat((minutos % 60).toFixed(2));
      return `${horas}h ${minutosRestantes}m`;
    };

const handleFechaInicioChange = (e) => {
  setRangoFechas(prev => ({
    ...prev,
    inicio: new Date(e.target.value + "T00:00:00")
  }));
};

const handleFechaFinChange = (e) => {
  setRangoFechas(prev => ({
    ...prev,
    fin: new Date(e.target.value + "T00:00:00")
  }));
};
    useEffect(() => {
      setPage(0);
    }, [tipoFiltro]);

      // Función para manejar cambio de sucursal
    const handleSucursalChange = (event) => {
      const nuevaSucursal = event.target.value;

      const sucursalInt = nuevaSucursal ? parseInt(nuevaSucursal) : null;

      setSucursalSeleccionada(sucursalInt);
      fetchDatosDashboard(rangoFechas.inicio, rangoFechas.fin, sucursalInt);
    };

      // Función para formatear fecha para input type="date"
  const formatearFechaParaInput = (fecha) => {
    return fecha.toISOString().split('T')[0];
  };

  const getDataTabla = () => {
    switch (tipoFiltro) {
      case "activasFecha":
        return pausasActivas;

      case "finalizadas":
        return pausasFinalizadas;

      case "activasTodas":
      default: return pausasActivasTodas;
    }
  }

  //Datos para grafico Activas vs Finalizadas
  const total = (resumen.pausasActivasFecha || 0) + (resumen.pausasFinalizadasFecha || 0); 

  const dataRatio = [
    {
      name: "Activas",
      value: resumen.pausasActivasFecha || 0
    },
    {
      name: "Finalizadas",
      value: resumen.pausasFinalizadasFecha || 0
    }
  ];

  const exportarExcel = () => {
    const datos = getDataTabla() || [];
    const datosExportar = datos.map(row => ({
      'Colaborador': row.colaborador,
      'Motivo': row.motivo_pausa,
      'Sucursal': row.sucursal,
      'Ubicacion': row.ubicacion,
      'Hora de Inicio': row.hora_inicio,
      'Hora de Fin': row.hora_fin,
    }))
  

 const wb = XLSX.utils.book_new();
 const ws = XLSX.utils.json_to_sheet(datosExportar);

 //Ajustarv ancho de columnas
 ws['!cols'] = [
  {wch: 25},
  {wch: 40},
  {wch: 30},
  {wch: 20},
  {wch: 20},
  {wch: 40}
 ];

 XLSX.utils.book_append_sheet(wb, ws, 'Pausas Colaboradores');
 XLSX.writeFile(wb, `Pausas Colaboradores_${new Date().toISOString().split('T')[0]}.xlsx`);
}

    return (
      <div className="right_col" role="main">
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <h3>Dashboard - Pausas</h3>
            </div>

            <div className="title_right">
          <div className="col-md-7 col-sm-7 form-group pull-right top_search">

            {/* Fecha */}
            <div className="input-group">
              <span className="input-group-addon">
                <i className="fa fa-calendar"></i>
              </span>
              <input
                type="date"
                className="form-control"
                value={formatearFechaParaInput(rangoFechas.inicio)}
                onChange={(e) =>
                  setRangoFechas(prev => ({
                    ...prev,
                    inicio: new Date(e.target.value + "T00:00:00")
                  }))
                }
                style={{ borderRadius: 0 }}
              />
              <div className="x_title">
                <span> a </span>
               </div>
                <input
                type="date"
                className="form-control"
                value={formatearFechaParaInput(rangoFechas.fin)}
                onChange={(e) =>
                  setRangoFechas(prev => ({
                    ...prev,
                    fin: new Date(e.target.value + "T00:00:00")
                  }))
                }
                style={{ borderRadius: 0 }}
              />
              <span className="input-group-btn">
                <button 
                  className="btn btn-default"
                  type="button"
                  onClick={() => fetchDatosDashboard()}
                  title="Actualizar datos"
                >
                  <i className="fa fa-refresh"></i>
                </button>

                <button 
                  className="btn btn-primary"
                  onClick={() => {
                    const hoy = new Date();

                    setRangoFechas(prev => ({
                      ...prev,
                      inicio: hoy,
                      fin: hoy
                    }));
                  }}
                >
                  Hoy
                </button>
              </span>
            </div>

            {/* Sucursal */}
            <div className="input-group" style={{ marginTop: '6px' }}>
              <span className="input-group-addon">
                <i className="fa fa-building"></i>
              </span>
              <select
                className="form-control"
                value={sucursalSeleccionada ?? ""}
                onChange={handleSucursalChange}
              >
                <option value="">Todas las sucursales</option>
                {sucursales.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.nombre}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>
      </div>

      <div className="clearfix"></div>

      {/* 🔹 KPIs */}
      <div className="row">
        <div className="col-md-3 col-sm-6 col-xs-12">
          <div 
            className="x_panel tile"
            onClick={() => setTipoFiltro("activasFecha")}
            style={{
              cursor: "pointer",
              border: tipoFiltro === "activasFecha" ? "2px solid #0275d8" : ""
            }}
            >
            <div className="x_title">
              <h2>Pausas Activas (Filtro)</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 48, color: "#0275d8" }}>
                {resumen.pausasActivasFecha || 0}
              </h1>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6 col-xs-12">
          <div
            className="x_panel tile"
            onClick={() => setTipoFiltro("finalizadas")}
            style={{
              cursor: "pointer",
              border: tipoFiltro === "finalizadas" ? "2px solid #5bc0de" : ""
            }}
            >
            <div className="x_title">
              <h2>Finalizadas (Filtro)</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 48, color: "#5bc0de" }}>
                {resumen.pausasFinalizadasFecha || 0}
              </h1>
            </div>
          </div>
        </div>

      </div>

      {/* 🔹 GRÁFICAS */}
      <div className="row">

        {/* Motivos */}
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x-panel">
            <div className="x_title">
              <h2> Pausas por Motivo </h2>
            </div>
            
            <div className="x_content">
              <ResponsiveContainer width="100%" height={400}>
                  <PieChart>
                    <Pie
                      data={motivos}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={60}
                      outerRadius={110}
                      paddingAngle={3}
                      label={({ name, percent}) => 
                        `${name} (${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {motivos.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={[
                            "#d9534f", // rojo
                            "#0275d8", // azul
                            "#5bc0de", // celeste
                            "#5cb85c", // verde
                            "#f0ad4e", // naranja
                            "#6f42c1", // morado
                            "#e84393"  // rosado
                          ][index % 7]}
                          />
                      ))}
                    </Pie>
                    < Tooltip formatter={(value, name) => [`${value} pausas`, name]} />
                    <Legend />
                  </PieChart>
              </ResponsiveContainer>
            </div>
        </div>
      </div>

      <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x-panel">
            <div className="x-title">
                <h2>Activas vs Finalizadas</h2>
            </div>
            <div className='x_content text-center'>
              <h4>Total: {total}</h4>

              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={dataRatio}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={60}
                    outerRadius={90}
                    label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                  >
                    <Cell fill='#f0ad4e' />
                    <Cell fill='#5bc0de' />
                  </Pie>
                  <Tooltip formatter={(value) => `${value} pausas`} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
      </div>

      </div>
      

      {/* 🔹 TABLA TIEMPO REAL */}
      <div className="row">
        <div className="col-md-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>
                {tipoFiltro === "activas" && "Pausas Activas"}
                {tipoFiltro === "activasFecha" && "Pausas Activas (Filtro)"}
                {tipoFiltro === "finalizadas" && "Pausas Finalizadas"}
              </h2>
            </div>


            <div className="x_content">
              <Box sx={{mb: 2, display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                  variant = "outlined"
                  color = "primary"
                  startIcon = {<GetApp />}
                  onClick = {exportarExcel}
                  display = {!tienePermiso('Exportar Excel Pausas')}
                >
                  Exportar a Excel
                </Button>
              </Box>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Colaborador</th>
                    <th>Motivo</th>
                    <th>Sucursal</th>
                    <th>Ubicación</th>
                    <th>Inicio</th>
                    <th>Fin</th>
                    {/* <th>Min</th> */}
                  </tr>
                </thead>
                <tbody>
                  {getDataTabla().map(p => (
                    <tr key={p.id_motivo_pausa}>
                      <td>{p.colaborador}</td>
                      <td>{p.motivo_pausa}</td>
                      <td>{p.sucursal}</td>
                      <td>{p.ubicacion}</td>
                      {/* <td>{p.hora_inicio}</td> */}
                      <td>{p.hora_inicio?.replace("T", " ")}</td>
                      <td>{p.hora_fin?.replace("T", " ")}</td>
                      {/* <td>{p.minutosEnPausa}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>

             
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <TablePagination
                  component="div"
                  count={totalRows || 0}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                  }}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  labelRowsPerPage="Filas por página:"
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      </div>
      </div>
    );
};

export default DashboardPausa;